<style lang="less" scoped></style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top">
        <div class="page-content">
          <div class="title">{{ deviceTitle }}数据获取率数据统计</div>
          <div class="content">
            <el-form
              label-width="80px"
              :rules="rules"
              :model="ruleForm"
              ref="ruleForm"
            >
              <el-row :gutter="10">
                <div class="searchs">
                  <el-form-item label="时间" prop="startTime">
                    <el-date-picker
                      v-model="ruleForm.startTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="开始时间"
                      clearable
                    ></el-date-picker>
                    <!-- <el-form-item label="时间" prop="time">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                    </el-form-item>-->
                  </el-form-item>
                  <div class="interval">-</div>
                  <el-form-item label label-width="0" prop="endTime">
                    <el-date-picker
                      v-model="ruleForm.endTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="结束时间"
                      clearable
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item
                    label="自动站"
                    prop="station"
                    v-if="station.length > 1"
                  >
                    <el-select
                      v-model="ruleForm.station"
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in station"
                        :key="index"
                        :label="item.station_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button
                    class="subbtn"
                    @click="search()"
                    type="primary"
                    :loading="submitBtn.isBtnLoading"
                    :disabled="submitBtn.isDisabled"
                    >{{ submitBtn.btnText }}</el-button
                  >
                </div>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="page-main-bottom">
        <div class="content-list">
          <calendar-echarts-option
            :echart-id="'echart1'"
            :option-data="optionData"
            v-on:downCsvBtn="downCsvBtn"
            v-on:achieveDataUpdate="achieveDataUpdate"
          ></calendar-echarts-option>
        </div>
        <a id="csv"></a>
      </div>
    </div>
  </div>
</template>

<script>
import calendarEchartsOption from "@/components/calendarEchartsOption"; //echarts渐变折线

export default {
  name: "dataAcquisition", //高压电离室数据分析-数据获取率
  components: {
    calendarEchartsOption: calendarEchartsOption
  },
  data() {
    return {
      pageLoading: false, //页面loading
      ruleForm: {
        startTime: "",
        endTime: "",
        station: ""
      },
      rules: {
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "change" }
        ],
        station: [
          { required: true, message: "请选择自动站", trigger: "change" }
        ]
      },
      submitBtn: {
        btnText: "查询数据",
        isLoading: false,
        isDisabled: false
      },
      optionData: {
        title: "获取率",
        unit: "nGy/h",
        deviceId: "",
        time: [],
        data: []
      },
      deviceTitle: "", //设备名称
      station: [] //自动站
    };
  },
  computed: {
    id: function() {
      return this.$route.params.id || ""; //设备id
    },
    type: function() {
      return this.$route.params.type || ""; //设备type
    }
  },
  methods: {
    search() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let startDate = new Date(this.ruleForm.startTime);
          let endDate = new Date(this.ruleForm.endTime);
          if (startDate > endDate) {
            this.$message.error("开始时间不能大于结束时间");
            return false;
          }
          this.$$http("echartsAchieve", {
            device: this.ruleForm.station,
            device_data_model: this.type,
            start_time: this.ruleForm.startTime,
            end_time: this.ruleForm.endTime
          })
            .then(results => {
              if (results.data && results.status == 200) {
                let datas = results.data;
                this.optionData.data = [];
                for (let i in datas) {
                  this.optionData.data.push([
                    datas[i].date,
                    datas[i].receive_rate
                  ]);
                }
                this.optionData.time = [
                  this.optionData.data[0][0],
                  this.optionData.data[this.optionData.data.length - 1][0]
                ];
                this.optionData.deviceId = this.ruleForm.station;
                console.log("datas", this.optionData);
              } else {
                this.$message.error(
                  results.data.msg ? results.data.msg : "查询失败"
                );
              }
            })
            .catch(err => {});
        }
      });
    },
    //下载获取率数据
    downCsvBtn() {
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        // this.optionData.time = this.ruleForm.time;
        this.$$http("echartsAchieveDownCsv", {
          device: this.ruleForm.station,
          device_data_model: this.type,
          start_time: this.ruleForm.startTime,
          end_time: this.ruleForm.endTime
        })
          .then(results => {
            if (results.data && results.status == 200) {
              let csv = this.optionData.title + ".csv";
              let anchor = document.getElementById("csv");
              anchor.href =
                "data:text/csv;charset=utf-8," +
                encodeURIComponent(results.data);
              anchor.target = "_blank";
              anchor.download = csv;
              anchor.click();
              this.$message.success("下载成功");
            } else {
              this.$message.error(
                results.data.msg ? results.data.msg : "下载失败"
              );
            }
          })
          .catch(err => {});
      } else {
        this.$message.error("请选择时间");
      }
    },
    //补传数据成功后，更新数据列表
    achieveDataUpdate(isUpdate) {
      if (isUpdate) this.search();
    },
    //获取自动站
    getStationList() {
      this.pbFunc.stationList(this.id).then(res => {
        // console.log("自动站列表", res);
        this.station = res.other_station_devices;
        if (this.station.length == 1) {
          console.log("999");
          this.ruleForm.station = this.station[0].id;
        }
      });
    }
  },
  created() {
    this.getStationList();
    this.deviceTitle = this.pbFunc.deviceName(this.id, this.type);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dataStatistics/dataAcquisition.vue